import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Compra de Material",
    items: [
      { label: "Ordenes de Compra",  icon: "fas fa-shopping-basket", href: "/ListadoOrdenesCompra",   key: "compras.oc.ver"      },
      { label: "Recepción",          icon: "fas fa-cart-plus",       href: "/ListadoCompras",         key: "compras.recepcion.ver" },
      { label: "Compra Directa",     icon: "fas fa-bolt",            href: "/CompraDirecta",          key: "compras.directa.ver" },
      // { label: "Faltantes en Compras", icon: "fas fa-minus-circle",  href: "/ListadoComprasFaltante", perm: "menu_compras" },
      { label: "Devoluciones",       icon: "fas fa-undo-alt",        href: "/ListadoDevolucionesProveedores", key: "compras.devoluciones.ver" },
    ],
  },
  {
    title: "Compra de Producto Terminado",
    items: [
      { label: "OC Producto Terminado", icon: "fas fa-box",          href: "/CompraArticulos",        key: "compras.ocPT.ver" },
      { label: "Recepción Producto Terminado", icon: "fas fa-truck-loading", href: "/RecepcionArticulos", key: "compras.recepcionPT.ver" },
      { label: "Compra Directa PT",     icon: "fas fa-bolt",         href: "/CompraDirectaPT",        key: "compras.directaPT.ver" },
    ],
  },
  {
    title: "Reportes",
    items: [
      { label: "Reporte Compras Material", icon: "fas fa-cart-plus", href: "/ReporteComprasMaterial",      key: "compras.reporteCompras.ver" },
      { label: "Reporte OC Material",    icon: "fas fa-cart-plus", href: "/ReporteOrdenesComprasMaterial", key: "compras.reporteOC.ver" },
    ],
  },
];

function BotonesCompras() {
  return (
    <MenuGrid
      title="Compras"
      subtitle="Órdenes de compra, recepción y reportes de material"
      icon="fas fa-truck"
      accent={{ color: "#f59e0b", bg: "#fffbeb" }}
      modulo="compras"
      sections={SECTIONS}
    />
  );
}

export default BotonesCompras;
